// src/App.js
import { useEffect } from 'react';
import Router from "./routes";
import { getIsAndroid } from './config/config';
import { initializeKioskServices, shutdownKioskServices } from './services/androidKiosk';
import './App.css';

export default function App() {
  useEffect(() => {
    // Use dynamic check - static isAndroid may be false if config.js loaded before Capacitor
    const isAndroidDevice = getIsAndroid();
    console.log('📱 Platform check: isAndroid =', isAndroidDevice, '| Capacitor =', window.Capacitor !== undefined);

    if (isAndroidDevice) {
      console.log('📱 Initializing Android kiosk mode...');
      initializeKioskServices();

      return () => {
        shutdownKioskServices();
      };
    }
  }, []);

  return (
    <div>
      <Router />
    </div>
  );
}
